module.exports = __webpack_public_path__ + "img/scale.71ba13ed.svg";